/**
 * @popperjs/core v2.11.5 - MIT License
 */

!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?t(exports):"function"==typeof define&&define.amd?define(["exports"],t):t((e="undefined"!=typeof globalThis?globalThis:e||self).Popper={})}(this,(function(e){"use strict";function t(e){if(null==e)return window;if("[object Window]"!==e.toString()){var t=e.ownerDocument;return t&&t.defaultView||window}return e}function n(e){return e instanceof t(e).Element||e instanceof Element}function r(e){return e instanceof t(e).HTMLElement||e instanceof HTMLElement}function o(e){return"undefined"!=typeof ShadowRoot&&(e instanceof t(e).ShadowRoot||e instanceof ShadowRoot)}var i=Math.max,a=Math.min,s=Math.round;function f(e,t){void 0===t&&(t=!1);var n=e.getBoundingClientRect(),o=1,i=1;if(r(e)&&t){var a=e.offsetHeight,f=e.offsetWidth;f>0&&(o=s(n.width)/f||1),a>0&&(i=s(n.height)/a||1)}return{width:n.width/o,height:n.height/i,top:n.top/i,right:n.right/o,bottom:n.bottom/i,left:n.left/o,x:n.left/o,y:n.top/i}}function c(e){var n=t(e);return{scrollLeft:n.pageXOffset,scrollTop:n.pageYOffset}}function p(e){return e?(e.nodeName||"").toLowerCase():null}function u(e){return((n(e)?e.ownerDocument:e.document)||window.document).documentElement}function l(e){return f(u(e)).left+c(e).scrollLeft}function d(e){return t(e).getComputedStyle(e)}function h(e){var t=d(e),n=t.overflow,r=t.overflowX,o=t.overflowY;return/auto|scroll|overlay|hidden/.test(n+o+r)}function m(e,n,o){void 0===o&&(o=!1);var i,a,d=r(n),m=r(n)&&function(e){var t=e.getBoundingClientRect(),n=s(t.width)/e.offsetWidth||1,r=s(t.height)/e.offsetHeight||1;return 1!==n||1!==r}(n),v=u(n),g=f(e,m),y={scrollLeft:0,scrollTop:0},b={x:0,y:0};return(d||!d&&!o)&&(("body"!==p(n)||h(v))&&(y=(i=n)!==t(i)&&r(i)?{scrollLeft:(a=i).scrollLeft,scrollTop:a.scrollTop}:c(i)),r(n)?((b=f(n,!0)).x+=n.clientLeft,b.y+=n.clientTop):v&&(b.x=l(v))),{x:g.left+y.scrollLeft-b.x,y:g.top+y.scrollTop-b.y,width:g.width,height:g.height}}function v(e){var t=f(e),n=e.offsetWidth,r=e.offsetHeight;return Math.abs(t.width-n)<=1&&(n=t.width),Math.abs(t.height-r)<=1&&(r=t.height),{x:e.offsetLeft,y:e.offsetTop,width:n,height:r}}function g(e){return"html"===p(e)?e:e.assignedSlot||e.parentNode||(o(e)?e.host:null)||u(e)}function y(e){return["html","body","#document"].indexOf(p(e))>=0?e.ownerDocument.body:r(e)&&h(e)?e:y(g(e))}function b(e,n){var r;void 0===n&&(n=[]);var o=y(e),i=o===(null==(r=e.ownerDocument)?void 0:r.body),a=t(o),s=i?[a].concat(a.visualViewport||[],h(o)?o:[]):o,f=n.concat(s);return i?f:f.concat(b(g(s)))}function x(e){return["table","td","th"].indexOf(p(e))>=0}function w(e){return r(e)&&"fixed"!==d(e).position?e.offsetParent:null}function O(e){for(var n=t(e),i=w(e);i&&x(i)&&"static"===d(i).position;)i=w(i);return i&&("html"===p(i)||"body"===p(i)&&"static"===d(i).position)?n:i||function(e){var t=-1!==navigator.userAgent.toLowerCase().indexOf("firefox");if(-1!==navigator.userAgent.indexOf("Trident")&&r(e)&&"fixed"===d(e).position)return null;var n=g(e);for(o(n)&&(n=n.host);r(n)&&["html","body"].indexOf(p(n))<0;){var i=d(n);if("none"!==i.transform||"none"!==i.perspective||"paint"===i.contain||-1!==["transform","perspective"].indexOf(i.willChange)||t&&"filter"===i.willChange||t&&i.filter&&"none"!==i.filter)return n;n=n.parentNode}return null}(e)||n}var j="top",E="bottom",D="right",A="left",L="auto",P=[j,E,D,A],M="start",k="end",W="viewport",B="popper",H=P.reduce((function(e,t){return e.concat([t+"-"+M,t+"-"+k])}),[]),T=[].concat(P,[L]).reduce((function(e,t){return e.concat([t,t+"-"+M,t+"-"+k])}),[]),R=["beforeRead","read","afterRead","beforeMain","main","afterMain","beforeWrite","write","afterWrite"];function S(e){var t=new Map,n=new Set,r=[];function o(e){n.add(e.name),[].concat(e.requires||[],e.requiresIfExists||[]).forEach((function(e){if(!n.has(e)){var r=t.get(e);r&&o(r)}})),r.push(e)}return e.forEach((function(e){t.set(e.name,e)})),e.forEach((function(e){n.has(e.name)||o(e)})),r}function C(e){return e.split("-")[0]}function q(e,t){var n=t.getRootNode&&t.getRootNode();if(e.contains(t))return!0;if(n&&o(n)){var r=t;do{if(r&&e.isSameNode(r))return!0;r=r.parentNode||r.host}while(r)}return!1}function V(e){return Object.assign({},e,{left:e.x,top:e.y,right:e.x+e.width,bottom:e.y+e.height})}function N(e,r){return r===W?V(function(e){var n=t(e),r=u(e),o=n.visualViewport,i=r.clientWidth,a=r.clientHeight,s=0,f=0;return o&&(i=o.width,a=o.height,/^((?!chrome|android).)*safari/i.test(navigator.userAgent)||(s=o.offsetLeft,f=o.offsetTop)),{width:i,height:a,x:s+l(e),y:f}}(e)):n(r)?function(e){var t=f(e);return t.top=t.top+e.clientTop,t.left=t.left+e.clientLeft,t.bottom=t.top+e.clientHeight,t.right=t.left+e.clientWidth,t.width=e.clientWidth,t.height=e.clientHeight,t.x=t.left,t.y=t.top,t}(r):V(function(e){var t,n=u(e),r=c(e),o=null==(t=e.ownerDocument)?void 0:t.body,a=i(n.scrollWidth,n.clientWidth,o?o.scrollWidth:0,o?o.clientWidth:0),s=i(n.scrollHeight,n.clientHeight,o?o.scrollHeight:0,o?o.clientHeight:0),f=-r.scrollLeft+l(e),p=-r.scrollTop;return"rtl"===d(o||n).direction&&(f+=i(n.clientWidth,o?o.clientWidth:0)-a),{width:a,height:s,x:f,y:p}}(u(e)))}function I(e,t,o){var s="clippingParents"===t?function(e){var t=b(g(e)),o=["absolute","fixed"].indexOf(d(e).position)>=0&&r(e)?O(e):e;return n(o)?t.filter((function(e){return n(e)&&q(e,o)&&"body"!==p(e)})):[]}(e):[].concat(t),f=[].concat(s,[o]),c=f[0],u=f.reduce((function(t,n){var r=N(e,n);return t.top=i(r.top,t.top),t.right=a(r.right,t.right),t.bottom=a(r.bottom,t.bottom),t.left=i(r.left,t.left),t}),N(e,c));return u.width=u.right-u.left,u.height=u.bottom-u.top,u.x=u.left,u.y=u.top,u}function _(e){return e.split("-")[1]}function F(e){return["top","bottom"].indexOf(e)>=0?"x":"y"}function U(e){var t,n=e.reference,r=e.element,o=e.placement,i=o?C(o):null,a=o?_(o):null,s=n.x+n.width/2-r.width/2,f=n.y+n.height/2-r.height/2;switch(i){case j:t={x:s,y:n.y-r.height};break;case E:t={x:s,y:n.y+n.height};break;case D:t={x:n.x+n.width,y:f};break;case A:t={x:n.x-r.width,y:f};break;default:t={x:n.x,y:n.y}}var c=i?F(i):null;if(null!=c){var p="y"===c?"height":"width";switch(a){case M:t[c]=t[c]-(n[p]/2-r[p]/2);break;case k:t[c]=t[c]+(n[p]/2-r[p]/2)}}return t}function z(e){return Object.assign({},{top:0,right:0,bottom:0,left:0},e)}function X(e,t){return t.reduce((function(t,n){return t[n]=e,t}),{})}function Y(e,t){void 0===t&&(t={});var r=t,o=r.placement,i=void 0===o?e.placement:o,a=r.boundary,s=void 0===a?"clippingParents":a,c=r.rootBoundary,p=void 0===c?W:c,l=r.elementContext,d=void 0===l?B:l,h=r.altBoundary,m=void 0!==h&&h,v=r.padding,g=void 0===v?0:v,y=z("number"!=typeof g?g:X(g,P)),b=d===B?"reference":B,x=e.rects.popper,w=e.elements[m?b:d],O=I(n(w)?w:w.contextElement||u(e.elements.popper),s,p),A=f(e.elements.reference),L=U({reference:A,element:x,strategy:"absolute",placement:i}),M=V(Object.assign({},x,L)),k=d===B?M:A,H={top:O.top-k.top+y.top,bottom:k.bottom-O.bottom+y.bottom,left:O.left-k.left+y.left,right:k.right-O.right+y.right},T=e.modifiersData.offset;if(d===B&&T){var R=T[i];Object.keys(H).forEach((function(e){var t=[D,E].indexOf(e)>=0?1:-1,n=[j,E].indexOf(e)>=0?"y":"x";H[e]+=R[n]*t}))}return H}var G={placement:"bottom",modifiers:[],strategy:"absolute"};function J(){for(var e=arguments.length,t=new Array(e),n=0;n<e;n++)t[n]=arguments[n];return!t.some((function(e){return!(e&&"function"==typeof e.getBoundingClientRect)}))}function K(e){void 0===e&&(e={});var t=e,r=t.defaultModifiers,o=void 0===r?[]:r,i=t.defaultOptions,a=void 0===i?G:i;return function(e,t,r){void 0===r&&(r=a);var i,s,f={placement:"bottom",orderedModifiers:[],options:Object.assign({},G,a),modifiersData:{},elements:{reference:e,popper:t},attributes:{},styles:{}},c=[],p=!1,u={state:f,setOptions:function(r){var i="function"==typeof r?r(f.options):r;l(),f.options=Object.assign({},a,f.options,i),f.scrollParents={reference:n(e)?b(e):e.contextElement?b(e.contextElement):[],popper:b(t)};var s,p,d=function(e){var t=S(e);return R.reduce((function(e,n){return e.concat(t.filter((function(e){return e.phase===n})))}),[])}((s=[].concat(o,f.options.modifiers),p=s.reduce((function(e,t){var n=e[t.name];return e[t.name]=n?Object.assign({},n,t,{options:Object.assign({},n.options,t.options),data:Object.assign({},n.data,t.data)}):t,e}),{}),Object.keys(p).map((function(e){return p[e]}))));return f.orderedModifiers=d.filter((function(e){return e.enabled})),f.orderedModifiers.forEach((function(e){var t=e.name,n=e.options,r=void 0===n?{}:n,o=e.effect;if("function"==typeof o){var i=o({state:f,name:t,instance:u,options:r}),a=function(){};c.push(i||a)}})),u.update()},forceUpdate:function(){if(!p){var e=f.elements,t=e.reference,n=e.popper;if(J(t,n)){f.rects={reference:m(t,O(n),"fixed"===f.options.strategy),popper:v(n)},f.reset=!1,f.placement=f.options.placement,f.orderedModifiers.forEach((function(e){return f.modifiersData[e.name]=Object.assign({},e.data)}));for(var r=0;r<f.orderedModifiers.length;r++)if(!0!==f.reset){var o=f.orderedModifiers[r],i=o.fn,a=o.options,s=void 0===a?{}:a,c=o.name;"function"==typeof i&&(f=i({state:f,options:s,name:c,instance:u})||f)}else f.reset=!1,r=-1}}},update:(i=function(){return new Promise((function(e){u.forceUpdate(),e(f)}))},function(){return s||(s=new Promise((function(e){Promise.resolve().then((function(){s=void 0,e(i())}))}))),s}),destroy:function(){l(),p=!0}};if(!J(e,t))return u;function l(){c.forEach((function(e){return e()})),c=[]}return u.setOptions(r).then((function(e){!p&&r.onFirstUpdate&&r.onFirstUpdate(e)})),u}}var Q={passive:!0};var Z={name:"eventListeners",enabled:!0,phase:"write",fn:function(){},effect:function(e){var n=e.state,r=e.instance,o=e.options,i=o.scroll,a=void 0===i||i,s=o.resize,f=void 0===s||s,c=t(n.elements.popper),p=[].concat(n.scrollParents.reference,n.scrollParents.popper);return a&&p.forEach((function(e){e.addEventListener("scroll",r.update,Q)})),f&&c.addEventListener("resize",r.update,Q),function(){a&&p.forEach((function(e){e.removeEventListener("scroll",r.update,Q)})),f&&c.removeEventListener("resize",r.update,Q)}},data:{}};var $={name:"popperOffsets",enabled:!0,phase:"read",fn:function(e){var t=e.state,n=e.name;t.modifiersData[n]=U({reference:t.rects.reference,element:t.rects.popper,strategy:"absolute",placement:t.placement})},data:{}},ee={top:"auto",right:"auto",bottom:"auto",left:"auto"};function te(e){var n,r=e.popper,o=e.popperRect,i=e.placement,a=e.variation,f=e.offsets,c=e.position,p=e.gpuAcceleration,l=e.adaptive,h=e.roundOffsets,m=e.isFixed,v=f.x,g=void 0===v?0:v,y=f.y,b=void 0===y?0:y,x="function"==typeof h?h({x:g,y:b}):{x:g,y:b};g=x.x,b=x.y;var w=f.hasOwnProperty("x"),L=f.hasOwnProperty("y"),P=A,M=j,W=window;if(l){var B=O(r),H="clientHeight",T="clientWidth";if(B===t(r)&&"static"!==d(B=u(r)).position&&"absolute"===c&&(H="scrollHeight",T="scrollWidth"),B=B,i===j||(i===A||i===D)&&a===k)M=E,b-=(m&&B===W&&W.visualViewport?W.visualViewport.height:B[H])-o.height,b*=p?1:-1;if(i===A||(i===j||i===E)&&a===k)P=D,g-=(m&&B===W&&W.visualViewport?W.visualViewport.width:B[T])-o.width,g*=p?1:-1}var R,S=Object.assign({position:c},l&&ee),C=!0===h?function(e){var t=e.x,n=e.y,r=window.devicePixelRatio||1;return{x:s(t*r)/r||0,y:s(n*r)/r||0}}({x:g,y:b}):{x:g,y:b};return g=C.x,b=C.y,p?Object.assign({},S,((R={})[M]=L?"0":"",R[P]=w?"0":"",R.transform=(W.devicePixelRatio||1)<=1?"translate("+g+"px, "+b+"px)":"translate3d("+g+"px, "+b+"px, 0)",R)):Object.assign({},S,((n={})[M]=L?b+"px":"",n[P]=w?g+"px":"",n.transform="",n))}var ne={name:"computeStyles",enabled:!0,phase:"beforeWrite",fn:function(e){var t=e.state,n=e.options,r=n.gpuAcceleration,o=void 0===r||r,i=n.adaptive,a=void 0===i||i,s=n.roundOffsets,f=void 0===s||s,c={placement:C(t.placement),variation:_(t.placement),popper:t.elements.popper,popperRect:t.rects.popper,gpuAcceleration:o,isFixed:"fixed"===t.options.strategy};null!=t.modifiersData.popperOffsets&&(t.styles.popper=Object.assign({},t.styles.popper,te(Object.assign({},c,{offsets:t.modifiersData.popperOffsets,position:t.options.strategy,adaptive:a,roundOffsets:f})))),null!=t.modifiersData.arrow&&(t.styles.arrow=Object.assign({},t.styles.arrow,te(Object.assign({},c,{offsets:t.modifiersData.arrow,position:"absolute",adaptive:!1,roundOffsets:f})))),t.attributes.popper=Object.assign({},t.attributes.popper,{"data-popper-placement":t.placement})},data:{}};var re={name:"applyStyles",enabled:!0,phase:"write",fn:function(e){var t=e.state;Object.keys(t.elements).forEach((function(e){var n=t.styles[e]||{},o=t.attributes[e]||{},i=t.elements[e];r(i)&&p(i)&&(Object.assign(i.style,n),Object.keys(o).forEach((function(e){var t=o[e];!1===t?i.removeAttribute(e):i.setAttribute(e,!0===t?"":t)})))}))},effect:function(e){var t=e.state,n={popper:{position:t.options.strategy,left:"0",top:"0",margin:"0"},arrow:{position:"absolute"},reference:{}};return Object.assign(t.elements.popper.style,n.popper),t.styles=n,t.elements.arrow&&Object.assign(t.elements.arrow.style,n.arrow),function(){Object.keys(t.elements).forEach((function(e){var o=t.elements[e],i=t.attributes[e]||{},a=Object.keys(t.styles.hasOwnProperty(e)?t.styles[e]:n[e]).reduce((function(e,t){return e[t]="",e}),{});r(o)&&p(o)&&(Object.assign(o.style,a),Object.keys(i).forEach((function(e){o.removeAttribute(e)})))}))}},requires:["computeStyles"]};var oe={name:"offset",enabled:!0,phase:"main",requires:["popperOffsets"],fn:function(e){var t=e.state,n=e.options,r=e.name,o=n.offset,i=void 0===o?[0,0]:o,a=T.reduce((function(e,n){return e[n]=function(e,t,n){var r=C(e),o=[A,j].indexOf(r)>=0?-1:1,i="function"==typeof n?n(Object.assign({},t,{placement:e})):n,a=i[0],s=i[1];return a=a||0,s=(s||0)*o,[A,D].indexOf(r)>=0?{x:s,y:a}:{x:a,y:s}}(n,t.rects,i),e}),{}),s=a[t.placement],f=s.x,c=s.y;null!=t.modifiersData.popperOffsets&&(t.modifiersData.popperOffsets.x+=f,t.modifiersData.popperOffsets.y+=c),t.modifiersData[r]=a}},ie={left:"right",right:"left",bottom:"top",top:"bottom"};function ae(e){return e.replace(/left|right|bottom|top/g,(function(e){return ie[e]}))}var se={start:"end",end:"start"};function fe(e){return e.replace(/start|end/g,(function(e){return se[e]}))}function ce(e,t){void 0===t&&(t={});var n=t,r=n.placement,o=n.boundary,i=n.rootBoundary,a=n.padding,s=n.flipVariations,f=n.allowedAutoPlacements,c=void 0===f?T:f,p=_(r),u=p?s?H:H.filter((function(e){return _(e)===p})):P,l=u.filter((function(e){return c.indexOf(e)>=0}));0===l.length&&(l=u);var d=l.reduce((function(t,n){return t[n]=Y(e,{placement:n,boundary:o,rootBoundary:i,padding:a})[C(n)],t}),{});return Object.keys(d).sort((function(e,t){return d[e]-d[t]}))}var pe={name:"flip",enabled:!0,phase:"main",fn:function(e){var t=e.state,n=e.options,r=e.name;if(!t.modifiersData[r]._skip){for(var o=n.mainAxis,i=void 0===o||o,a=n.altAxis,s=void 0===a||a,f=n.fallbackPlacements,c=n.padding,p=n.boundary,u=n.rootBoundary,l=n.altBoundary,d=n.flipVariations,h=void 0===d||d,m=n.allowedAutoPlacements,v=t.options.placement,g=C(v),y=f||(g===v||!h?[ae(v)]:function(e){if(C(e)===L)return[];var t=ae(e);return[fe(e),t,fe(t)]}(v)),b=[v].concat(y).reduce((function(e,n){return e.concat(C(n)===L?ce(t,{placement:n,boundary:p,rootBoundary:u,padding:c,flipVariations:h,allowedAutoPlacements:m}):n)}),[]),x=t.rects.reference,w=t.rects.popper,O=new Map,P=!0,k=b[0],W=0;W<b.length;W++){var B=b[W],H=C(B),T=_(B)===M,R=[j,E].indexOf(H)>=0,S=R?"width":"height",q=Y(t,{placement:B,boundary:p,rootBoundary:u,altBoundary:l,padding:c}),V=R?T?D:A:T?E:j;x[S]>w[S]&&(V=ae(V));var N=ae(V),I=[];if(i&&I.push(q[H]<=0),s&&I.push(q[V]<=0,q[N]<=0),I.every((function(e){return e}))){k=B,P=!1;break}O.set(B,I)}if(P)for(var F=function(e){var t=b.find((function(t){var n=O.get(t);if(n)return n.slice(0,e).every((function(e){return e}))}));if(t)return k=t,"break"},U=h?3:1;U>0;U--){if("break"===F(U))break}t.placement!==k&&(t.modifiersData[r]._skip=!0,t.placement=k,t.reset=!0)}},requiresIfExists:["offset"],data:{_skip:!1}};function ue(e,t,n){return i(e,a(t,n))}var le={name:"preventOverflow",enabled:!0,phase:"main",fn:function(e){var t=e.state,n=e.options,r=e.name,o=n.mainAxis,s=void 0===o||o,f=n.altAxis,c=void 0!==f&&f,p=n.boundary,u=n.rootBoundary,l=n.altBoundary,d=n.padding,h=n.tether,m=void 0===h||h,g=n.tetherOffset,y=void 0===g?0:g,b=Y(t,{boundary:p,rootBoundary:u,padding:d,altBoundary:l}),x=C(t.placement),w=_(t.placement),L=!w,P=F(x),k="x"===P?"y":"x",W=t.modifiersData.popperOffsets,B=t.rects.reference,H=t.rects.popper,T="function"==typeof y?y(Object.assign({},t.rects,{placement:t.placement})):y,R="number"==typeof T?{mainAxis:T,altAxis:T}:Object.assign({mainAxis:0,altAxis:0},T),S=t.modifiersData.offset?t.modifiersData.offset[t.placement]:null,q={x:0,y:0};if(W){if(s){var V,N="y"===P?j:A,I="y"===P?E:D,U="y"===P?"height":"width",z=W[P],X=z+b[N],G=z-b[I],J=m?-H[U]/2:0,K=w===M?B[U]:H[U],Q=w===M?-H[U]:-B[U],Z=t.elements.arrow,$=m&&Z?v(Z):{width:0,height:0},ee=t.modifiersData["arrow#persistent"]?t.modifiersData["arrow#persistent"].padding:{top:0,right:0,bottom:0,left:0},te=ee[N],ne=ee[I],re=ue(0,B[U],$[U]),oe=L?B[U]/2-J-re-te-R.mainAxis:K-re-te-R.mainAxis,ie=L?-B[U]/2+J+re+ne+R.mainAxis:Q+re+ne+R.mainAxis,ae=t.elements.arrow&&O(t.elements.arrow),se=ae?"y"===P?ae.clientTop||0:ae.clientLeft||0:0,fe=null!=(V=null==S?void 0:S[P])?V:0,ce=z+ie-fe,pe=ue(m?a(X,z+oe-fe-se):X,z,m?i(G,ce):G);W[P]=pe,q[P]=pe-z}if(c){var le,de="x"===P?j:A,he="x"===P?E:D,me=W[k],ve="y"===k?"height":"width",ge=me+b[de],ye=me-b[he],be=-1!==[j,A].indexOf(x),xe=null!=(le=null==S?void 0:S[k])?le:0,we=be?ge:me-B[ve]-H[ve]-xe+R.altAxis,Oe=be?me+B[ve]+H[ve]-xe-R.altAxis:ye,je=m&&be?function(e,t,n){var r=ue(e,t,n);return r>n?n:r}(we,me,Oe):ue(m?we:ge,me,m?Oe:ye);W[k]=je,q[k]=je-me}t.modifiersData[r]=q}},requiresIfExists:["offset"]};var de={name:"arrow",enabled:!0,phase:"main",fn:function(e){var t,n=e.state,r=e.name,o=e.options,i=n.elements.arrow,a=n.modifiersData.popperOffsets,s=C(n.placement),f=F(s),c=[A,D].indexOf(s)>=0?"height":"width";if(i&&a){var p=function(e,t){return z("number"!=typeof(e="function"==typeof e?e(Object.assign({},t.rects,{placement:t.placement})):e)?e:X(e,P))}(o.padding,n),u=v(i),l="y"===f?j:A,d="y"===f?E:D,h=n.rects.reference[c]+n.rects.reference[f]-a[f]-n.rects.popper[c],m=a[f]-n.rects.reference[f],g=O(i),y=g?"y"===f?g.clientHeight||0:g.clientWidth||0:0,b=h/2-m/2,x=p[l],w=y-u[c]-p[d],L=y/2-u[c]/2+b,M=ue(x,L,w),k=f;n.modifiersData[r]=((t={})[k]=M,t.centerOffset=M-L,t)}},effect:function(e){var t=e.state,n=e.options.element,r=void 0===n?"[data-popper-arrow]":n;null!=r&&("string"!=typeof r||(r=t.elements.popper.querySelector(r)))&&q(t.elements.popper,r)&&(t.elements.arrow=r)},requires:["popperOffsets"],requiresIfExists:["preventOverflow"]};function he(e,t,n){return void 0===n&&(n={x:0,y:0}),{top:e.top-t.height-n.y,right:e.right-t.width+n.x,bottom:e.bottom-t.height+n.y,left:e.left-t.width-n.x}}function me(e){return[j,D,E,A].some((function(t){return e[t]>=0}))}var ve={name:"hide",enabled:!0,phase:"main",requiresIfExists:["preventOverflow"],fn:function(e){var t=e.state,n=e.name,r=t.rects.reference,o=t.rects.popper,i=t.modifiersData.preventOverflow,a=Y(t,{elementContext:"reference"}),s=Y(t,{altBoundary:!0}),f=he(a,r),c=he(s,o,i),p=me(f),u=me(c);t.modifiersData[n]={referenceClippingOffsets:f,popperEscapeOffsets:c,isReferenceHidden:p,hasPopperEscaped:u},t.attributes.popper=Object.assign({},t.attributes.popper,{"data-popper-reference-hidden":p,"data-popper-escaped":u})}},ge=K({defaultModifiers:[Z,$,ne,re]}),ye=[Z,$,ne,re,oe,pe,le,de,ve],be=K({defaultModifiers:ye});e.applyStyles=re,e.arrow=de,e.computeStyles=ne,e.createPopper=be,e.createPopperLite=ge,e.defaultModifiers=ye,e.detectOverflow=Y,e.eventListeners=Z,e.flip=pe,e.hide=ve,e.offset=oe,e.popperGenerator=K,e.popperOffsets=$,e.preventOverflow=le,Object.defineProperty(e,"__esModule",{value:!0})}));
//# sourceMappingURL=popper.min.js.map

/**!
 * tippy.js v6.3.7
 * (c) 2017-2021 atomiks
 * MIT License
 */
(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('@popperjs/core')) :
		typeof define === 'function' && define.amd ? define(['@popperjs/core'], factory) :
			(global = global || self, global.tippy = factory(global.Popper));
}(this, (function (core) { 'use strict';

	var css = ".tippy-box[data-animation=fade][data-state=hidden]{opacity:0}[data-tippy-root]{max-width:calc(100vw - 10px)}.tippy-box{position:relative;background-color:#333;color:#fff;border-radius:4px;font-size:14px;line-height:1.4;white-space:normal;outline:0;transition-property:transform,visibility,opacity}.tippy-box[data-placement^=top]>.tippy-arrow{bottom:0}.tippy-box[data-placement^=top]>.tippy-arrow:before{bottom:-7px;left:0;border-width:8px 8px 0;border-top-color:initial;transform-origin:center top}.tippy-box[data-placement^=bottom]>.tippy-arrow{top:0}.tippy-box[data-placement^=bottom]>.tippy-arrow:before{top:-7px;left:0;border-width:0 8px 8px;border-bottom-color:initial;transform-origin:center bottom}.tippy-box[data-placement^=left]>.tippy-arrow{right:0}.tippy-box[data-placement^=left]>.tippy-arrow:before{border-width:8px 0 8px 8px;border-left-color:initial;right:-7px;transform-origin:center left}.tippy-box[data-placement^=right]>.tippy-arrow{left:0}.tippy-box[data-placement^=right]>.tippy-arrow:before{left:-7px;border-width:8px 8px 8px 0;border-right-color:initial;transform-origin:center right}.tippy-box[data-inertia][data-state=visible]{transition-timing-function:cubic-bezier(.54,1.5,.38,1.11)}.tippy-arrow{width:16px;height:16px;color:#333}.tippy-arrow:before{content:\"\";position:absolute;border-color:transparent;border-style:solid}.tippy-content{position:relative;padding:5px 9px;z-index:1}";

	function injectCSS(css) {
		var style = document.createElement('style');
		style.textContent = css;
		style.setAttribute('data-tippy-stylesheet', '');
		var head = document.head;
		var firstStyleOrLinkTag = document.querySelector('head>style,head>link');

		if (firstStyleOrLinkTag) {
			head.insertBefore(style, firstStyleOrLinkTag);
		} else {
			head.appendChild(style);
		}
	}

	var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
	var isIE11 = isBrowser ? // @ts-ignore
		!!window.msCrypto : false;

	var ROUND_ARROW = '<svg width="16" height="6" xmlns="http://www.w3.org/2000/svg"><path d="M0 6s1.796-.013 4.67-3.615C5.851.9 6.93.006 8 0c1.07-.006 2.148.887 3.343 2.385C14.233 6.005 16 6 16 6H0z"></svg>';
	var BOX_CLASS = "tippy-box";
	var CONTENT_CLASS = "tippy-content";
	var BACKDROP_CLASS = "tippy-backdrop";
	var ARROW_CLASS = "tippy-arrow";
	var SVG_ARROW_CLASS = "tippy-svg-arrow";
	var TOUCH_OPTIONS = {
		passive: true,
		capture: true
	};
	var TIPPY_DEFAULT_APPEND_TO = function TIPPY_DEFAULT_APPEND_TO() {
		return document.body;
	};

	function hasOwnProperty(obj, key) {
		return {}.hasOwnProperty.call(obj, key);
	}
	function getValueAtIndexOrReturn(value, index, defaultValue) {
		if (Array.isArray(value)) {
			var v = value[index];
			return v == null ? Array.isArray(defaultValue) ? defaultValue[index] : defaultValue : v;
		}

		return value;
	}
	function isType(value, type) {
		var str = {}.toString.call(value);
		return str.indexOf('[object') === 0 && str.indexOf(type + "]") > -1;
	}
	function invokeWithArgsOrReturn(value, args) {
		return typeof value === 'function' ? value.apply(void 0, args) : value;
	}
	function debounce(fn, ms) {
		// Avoid wrapping in `setTimeout` if ms is 0 anyway
		if (ms === 0) {
			return fn;
		}

		var timeout;
		return function (arg) {
			clearTimeout(timeout);
			timeout = setTimeout(function () {
				fn(arg);
			}, ms);
		};
	}
	function removeProperties(obj, keys) {
		var clone = Object.assign({}, obj);
		keys.forEach(function (key) {
			delete clone[key];
		});
		return clone;
	}
	function splitBySpaces(value) {
		return value.split(/\s+/).filter(Boolean);
	}
	function normalizeToArray(value) {
		return [].concat(value);
	}
	function pushIfUnique(arr, value) {
		if (arr.indexOf(value) === -1) {
			arr.push(value);
		}
	}
	function unique(arr) {
		return arr.filter(function (item, index) {
			return arr.indexOf(item) === index;
		});
	}
	function getBasePlacement(placement) {
		return placement.split('-')[0];
	}
	function arrayFrom(value) {
		return [].slice.call(value);
	}
	function removeUndefinedProps(obj) {
		return Object.keys(obj).reduce(function (acc, key) {
			if (obj[key] !== undefined) {
				acc[key] = obj[key];
			}

			return acc;
		}, {});
	}

	function div() {
		return document.createElement('div');
	}
	function isElement(value) {
		return ['Element', 'Fragment'].some(function (type) {
			return isType(value, type);
		});
	}
	function isNodeList(value) {
		return isType(value, 'NodeList');
	}
	function isMouseEvent(value) {
		return isType(value, 'MouseEvent');
	}
	function isReferenceElement(value) {
		return !!(value && value._tippy && value._tippy.reference === value);
	}
	function getArrayOfElements(value) {
		if (isElement(value)) {
			return [value];
		}

		if (isNodeList(value)) {
			return arrayFrom(value);
		}

		if (Array.isArray(value)) {
			return value;
		}

		return arrayFrom(document.querySelectorAll(value));
	}
	function setTransitionDuration(els, value) {
		els.forEach(function (el) {
			if (el) {
				el.style.transitionDuration = value + "ms";
			}
		});
	}
	function setVisibilityState(els, state) {
		els.forEach(function (el) {
			if (el) {
				el.setAttribute('data-state', state);
			}
		});
	}
	function getOwnerDocument(elementOrElements) {
		var _element$ownerDocumen;

		var _normalizeToArray = normalizeToArray(elementOrElements),
			element = _normalizeToArray[0]; // Elements created via a <template> have an ownerDocument with no reference to the body


		return element != null && (_element$ownerDocumen = element.ownerDocument) != null && _element$ownerDocumen.body ? element.ownerDocument : document;
	}
	function isCursorOutsideInteractiveBorder(popperTreeData, event) {
		var clientX = event.clientX,
			clientY = event.clientY;
		return popperTreeData.every(function (_ref) {
			var popperRect = _ref.popperRect,
				popperState = _ref.popperState,
				props = _ref.props;
			var interactiveBorder = props.interactiveBorder;
			var basePlacement = getBasePlacement(popperState.placement);
			var offsetData = popperState.modifiersData.offset;

			if (!offsetData) {
				return true;
			}

			var topDistance = basePlacement === 'bottom' ? offsetData.top.y : 0;
			var bottomDistance = basePlacement === 'top' ? offsetData.bottom.y : 0;
			var leftDistance = basePlacement === 'right' ? offsetData.left.x : 0;
			var rightDistance = basePlacement === 'left' ? offsetData.right.x : 0;
			var exceedsTop = popperRect.top - clientY + topDistance > interactiveBorder;
			var exceedsBottom = clientY - popperRect.bottom - bottomDistance > interactiveBorder;
			var exceedsLeft = popperRect.left - clientX + leftDistance > interactiveBorder;
			var exceedsRight = clientX - popperRect.right - rightDistance > interactiveBorder;
			return exceedsTop || exceedsBottom || exceedsLeft || exceedsRight;
		});
	}
	function updateTransitionEndListener(box, action, listener) {
		var method = action + "EventListener"; // some browsers apparently support `transition` (unprefixed) but only fire
		// `webkitTransitionEnd`...

		['transitionend', 'webkitTransitionEnd'].forEach(function (event) {
			box[method](event, listener);
		});
	}
	/**
	 * Compared to xxx.contains, this function works for dom structures with shadow
	 * dom
	 */

	function actualContains(parent, child) {
		var target = child;

		while (target) {
			var _target$getRootNode;

			if (parent.contains(target)) {
				return true;
			}

			target = target.getRootNode == null ? void 0 : (_target$getRootNode = target.getRootNode()) == null ? void 0 : _target$getRootNode.host;
		}

		return false;
	}

	var currentInput = {
		isTouch: false
	};
	var lastMouseMoveTime = 0;
	/**
	 * When a `touchstart` event is fired, it's assumed the user is using touch
	 * input. We'll bind a `mousemove` event listener to listen for mouse input in
	 * the future. This way, the `isTouch` property is fully dynamic and will handle
	 * hybrid devices that use a mix of touch + mouse input.
	 */

	function onDocumentTouchStart() {
		if (currentInput.isTouch) {
			return;
		}

		currentInput.isTouch = true;

		if (window.performance) {
			document.addEventListener('mousemove', onDocumentMouseMove);
		}
	}
	/**
	 * When two `mousemove` event are fired consecutively within 20ms, it's assumed
	 * the user is using mouse input again. `mousemove` can fire on touch devices as
	 * well, but very rarely that quickly.
	 */

	function onDocumentMouseMove() {
		var now = performance.now();

		if (now - lastMouseMoveTime < 20) {
			currentInput.isTouch = false;
			document.removeEventListener('mousemove', onDocumentMouseMove);
		}

		lastMouseMoveTime = now;
	}
	/**
	 * When an element is in focus and has a tippy, leaving the tab/window and
	 * returning causes it to show again. For mouse users this is unexpected, but
	 * for keyboard use it makes sense.
	 * TODO: find a better technique to solve this problem
	 */

	function onWindowBlur() {
		var activeElement = document.activeElement;

		if (isReferenceElement(activeElement)) {
			var instance = activeElement._tippy;

			if (activeElement.blur && !instance.state.isVisible) {
				activeElement.blur();
			}
		}
	}
	function bindGlobalEventListeners() {
		document.addEventListener('touchstart', onDocumentTouchStart, TOUCH_OPTIONS);
		window.addEventListener('blur', onWindowBlur);
	}

	function createMemoryLeakWarning(method) {
		var txt = method === 'destroy' ? 'n already-' : ' ';
		return [method + "() was called on a" + txt + "destroyed instance. This is a no-op but", 'indicates a potential memory leak.'].join(' ');
	}
	function clean(value) {
		var spacesAndTabs = /[ \t]{2,}/g;
		var lineStartWithSpaces = /^[ \t]*/gm;
		return value.replace(spacesAndTabs, ' ').replace(lineStartWithSpaces, '').trim();
	}

	function getDevMessage(message) {
		return clean("\n  %ctippy.js\n\n  %c" + clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development-only message. It will be removed in production.\n  ");
	}

	function getFormattedMessage(message) {
		return [getDevMessage(message), // title
			'color: #00C584; font-size: 1.3em; font-weight: bold;', // message
			'line-height: 1.5', // footer
			'color: #a6a095;'];
	} // Assume warnings and errors never have the same message

	var visitedMessages;

	{
		resetVisitedMessages();
	}

	function resetVisitedMessages() {
		visitedMessages = new Set();
	}
	function warnWhen(condition, message) {
		if (condition && !visitedMessages.has(message)) {
			var _console;

			visitedMessages.add(message);

			(_console = console).warn.apply(_console, getFormattedMessage(message));
		}
	}
	function errorWhen(condition, message) {
		if (condition && !visitedMessages.has(message)) {
			var _console2;

			visitedMessages.add(message);

			(_console2 = console).error.apply(_console2, getFormattedMessage(message));
		}
	}
	function validateTargets(targets) {
		var didPassFalsyValue = !targets;
		var didPassPlainObject = Object.prototype.toString.call(targets) === '[object Object]' && !targets.addEventListener;
		errorWhen(didPassFalsyValue, ['tippy() was passed', '`' + String(targets) + '`', 'as its targets (first) argument. Valid types are: String, Element,', 'Element[], or NodeList.'].join(' '));
		errorWhen(didPassPlainObject, ['tippy() was passed a plain object which is not supported as an argument', 'for virtual positioning. Use props.getReferenceClientRect instead.'].join(' '));
	}

	var pluginProps = {
		animateFill: false,
		followCursor: false,
		inlinePositioning: false,
		sticky: false
	};
	var renderProps = {
		allowHTML: false,
		animation: 'fade',
		arrow: true,
		content: '',
		inertia: false,
		maxWidth: 350,
		role: 'tooltip',
		theme: '',
		zIndex: 9999
	};
	var defaultProps = Object.assign({
		appendTo: TIPPY_DEFAULT_APPEND_TO,
		aria: {
			content: 'auto',
			expanded: 'auto'
		},
		delay: 0,
		duration: [300, 250],
		getReferenceClientRect: null,
		hideOnClick: true,
		ignoreAttributes: false,
		interactive: false,
		interactiveBorder: 2,
		interactiveDebounce: 0,
		moveTransition: '',
		offset: [0, 10],
		onAfterUpdate: function onAfterUpdate() {},
		onBeforeUpdate: function onBeforeUpdate() {},
		onCreate: function onCreate() {},
		onDestroy: function onDestroy() {},
		onHidden: function onHidden() {},
		onHide: function onHide() {},
		onMount: function onMount() {},
		onShow: function onShow() {},
		onShown: function onShown() {},
		onTrigger: function onTrigger() {},
		onUntrigger: function onUntrigger() {},
		onClickOutside: function onClickOutside() {},
		placement: 'top',
		plugins: [],
		popperOptions: {},
		render: null,
		showOnCreate: false,
		touch: true,
		trigger: 'mouseenter focus',
		triggerTarget: null
	}, pluginProps, renderProps);
	var defaultKeys = Object.keys(defaultProps);
	var setDefaultProps = function setDefaultProps(partialProps) {
		/* istanbul ignore else */
		{
			validateProps(partialProps, []);
		}

		var keys = Object.keys(partialProps);
		keys.forEach(function (key) {
			defaultProps[key] = partialProps[key];
		});
	};
	function getExtendedPassedProps(passedProps) {
		var plugins = passedProps.plugins || [];
		var pluginProps = plugins.reduce(function (acc, plugin) {
			var name = plugin.name,
				defaultValue = plugin.defaultValue;

			if (name) {
				var _name;

				acc[name] = passedProps[name] !== undefined ? passedProps[name] : (_name = defaultProps[name]) != null ? _name : defaultValue;
			}

			return acc;
		}, {});
		return Object.assign({}, passedProps, pluginProps);
	}
	function getDataAttributeProps(reference, plugins) {
		var propKeys = plugins ? Object.keys(getExtendedPassedProps(Object.assign({}, defaultProps, {
			plugins: plugins
		}))) : defaultKeys;
		var props = propKeys.reduce(function (acc, key) {
			var valueAsString = (reference.getAttribute("data-tippy-" + key) || '').trim();

			if (!valueAsString) {
				return acc;
			}

			if (key === 'content') {
				acc[key] = valueAsString;
			} else {
				try {
					acc[key] = JSON.parse(valueAsString);
				} catch (e) {
					acc[key] = valueAsString;
				}
			}

			return acc;
		}, {});
		return props;
	}
	function evaluateProps(reference, props) {
		var out = Object.assign({}, props, {
			content: invokeWithArgsOrReturn(props.content, [reference])
		}, props.ignoreAttributes ? {} : getDataAttributeProps(reference, props.plugins));
		out.aria = Object.assign({}, defaultProps.aria, out.aria);
		out.aria = {
			expanded: out.aria.expanded === 'auto' ? props.interactive : out.aria.expanded,
			content: out.aria.content === 'auto' ? props.interactive ? null : 'describedby' : out.aria.content
		};
		return out;
	}
	function validateProps(partialProps, plugins) {
		if (partialProps === void 0) {
			partialProps = {};
		}

		if (plugins === void 0) {
			plugins = [];
		}

		var keys = Object.keys(partialProps);
		keys.forEach(function (prop) {
			var nonPluginProps = removeProperties(defaultProps, Object.keys(pluginProps));
			var didPassUnknownProp = !hasOwnProperty(nonPluginProps, prop); // Check if the prop exists in `plugins`

			if (didPassUnknownProp) {
				didPassUnknownProp = plugins.filter(function (plugin) {
					return plugin.name === prop;
				}).length === 0;
			}

			warnWhen(didPassUnknownProp, ["`" + prop + "`", "is not a valid prop. You may have spelled it incorrectly, or if it's", 'a plugin, forgot to pass it in an array as props.plugins.', '\n\n', 'All props: https://atomiks.github.io/tippyjs/v6/all-props/\n', 'Plugins: https://atomiks.github.io/tippyjs/v6/plugins/'].join(' '));
		});
	}

	var innerHTML = function innerHTML() {
		return 'innerHTML';
	};

	function dangerouslySetInnerHTML(element, html) {
		element[innerHTML()] = html;
	}

	function createArrowElement(value) {
		var arrow = div();

		if (value === true) {
			arrow.className = ARROW_CLASS;
		} else {
			arrow.className = SVG_ARROW_CLASS;

			if (isElement(value)) {
				arrow.appendChild(value);
			} else {
				dangerouslySetInnerHTML(arrow, value);
			}
		}

		return arrow;
	}

	function setContent(content, props) {
		if (isElement(props.content)) {
			dangerouslySetInnerHTML(content, '');
			content.appendChild(props.content);
		} else if (typeof props.content !== 'function') {
			if (props.allowHTML) {
				dangerouslySetInnerHTML(content, props.content);
			} else {
				content.textContent = props.content;
			}
		}
	}
	function getChildren(popper) {
		var box = popper.firstElementChild;
		var boxChildren = arrayFrom(box.children);
		return {
			box: box,
			content: boxChildren.find(function (node) {
				return node.classList.contains(CONTENT_CLASS);
			}),
			arrow: boxChildren.find(function (node) {
				return node.classList.contains(ARROW_CLASS) || node.classList.contains(SVG_ARROW_CLASS);
			}),
			backdrop: boxChildren.find(function (node) {
				return node.classList.contains(BACKDROP_CLASS);
			})
		};
	}
	function render(instance) {
		var popper = div();
		var box = div();
		box.className = BOX_CLASS;
		box.setAttribute('data-state', 'hidden');
		box.setAttribute('tabindex', '-1');
		var content = div();
		content.className = CONTENT_CLASS;
		content.setAttribute('data-state', 'hidden');
		setContent(content, instance.props);
		popper.appendChild(box);
		box.appendChild(content);
		onUpdate(instance.props, instance.props);

		function onUpdate(prevProps, nextProps) {
			var _getChildren = getChildren(popper),
				box = _getChildren.box,
				content = _getChildren.content,
				arrow = _getChildren.arrow;

			if (nextProps.theme) {
				box.setAttribute('data-theme', nextProps.theme);
			} else {
				box.removeAttribute('data-theme');
			}

			if (typeof nextProps.animation === 'string') {
				box.setAttribute('data-animation', nextProps.animation);
			} else {
				box.removeAttribute('data-animation');
			}

			if (nextProps.inertia) {
				box.setAttribute('data-inertia', '');
			} else {
				box.removeAttribute('data-inertia');
			}

			box.style.maxWidth = typeof nextProps.maxWidth === 'number' ? nextProps.maxWidth + "px" : nextProps.maxWidth;

			if (nextProps.role) {
				box.setAttribute('role', nextProps.role);
			} else {
				box.removeAttribute('role');
			}

			if (prevProps.content !== nextProps.content || prevProps.allowHTML !== nextProps.allowHTML) {
				setContent(content, instance.props);
			}

			if (nextProps.arrow) {
				if (!arrow) {
					box.appendChild(createArrowElement(nextProps.arrow));
				} else if (prevProps.arrow !== nextProps.arrow) {
					box.removeChild(arrow);
					box.appendChild(createArrowElement(nextProps.arrow));
				}
			} else if (arrow) {
				box.removeChild(arrow);
			}
		}

		return {
			popper: popper,
			onUpdate: onUpdate
		};
	} // Runtime check to identify if the render function is the default one; this
	// way we can apply default CSS transitions logic and it can be tree-shaken away

	render.$$tippy = true;

	var idCounter = 1;
	var mouseMoveListeners = []; // Used by `hideAll()`

	var mountedInstances = [];
	function createTippy(reference, passedProps) {
		var props = evaluateProps(reference, Object.assign({}, defaultProps, getExtendedPassedProps(removeUndefinedProps(passedProps)))); // ===========================================================================
		// 🔒 Private members
		// ===========================================================================

		var showTimeout;
		var hideTimeout;
		var scheduleHideAnimationFrame;
		var isVisibleFromClick = false;
		var didHideDueToDocumentMouseDown = false;
		var didTouchMove = false;
		var ignoreOnFirstUpdate = false;
		var lastTriggerEvent;
		var currentTransitionEndListener;
		var onFirstUpdate;
		var listeners = [];
		var debouncedOnMouseMove = debounce(onMouseMove, props.interactiveDebounce);
		var currentTarget; // ===========================================================================
		// 🔑 Public members
		// ===========================================================================

		var id = idCounter++;
		var popperInstance = null;
		var plugins = unique(props.plugins);
		var state = {
			// Is the instance currently enabled?
			isEnabled: true,
			// Is the tippy currently showing and not transitioning out?
			isVisible: false,
			// Has the instance been destroyed?
			isDestroyed: false,
			// Is the tippy currently mounted to the DOM?
			isMounted: false,
			// Has the tippy finished transitioning in?
			isShown: false
		};
		var instance = {
			// properties
			id: id,
			reference: reference,
			popper: div(),
			popperInstance: popperInstance,
			props: props,
			state: state,
			plugins: plugins,
			// methods
			clearDelayTimeouts: clearDelayTimeouts,
			setProps: setProps,
			setContent: setContent,
			show: show,
			hide: hide,
			hideWithInteractivity: hideWithInteractivity,
			enable: enable,
			disable: disable,
			unmount: unmount,
			destroy: destroy
		}; // TODO: Investigate why this early return causes a TDZ error in the tests —
		// it doesn't seem to happen in the browser

		/* istanbul ignore if */

		if (!props.render) {
			{
				errorWhen(true, 'render() function has not been supplied.');
			}

			return instance;
		} // ===========================================================================
		// Initial mutations
		// ===========================================================================


		var _props$render = props.render(instance),
			popper = _props$render.popper,
			onUpdate = _props$render.onUpdate;

		popper.setAttribute('data-tippy-root', '');
		popper.id = "tippy-" + instance.id;
		instance.popper = popper;
		reference._tippy = instance;
		popper._tippy = instance;
		var pluginsHooks = plugins.map(function (plugin) {
			return plugin.fn(instance);
		});
		var hasAriaExpanded = reference.hasAttribute('aria-expanded');
		addListeners();
		handleAriaExpandedAttribute();
		handleStyles();
		invokeHook('onCreate', [instance]);

		if (props.showOnCreate) {
			scheduleShow();
		} // Prevent a tippy with a delay from hiding if the cursor left then returned
		// before it started hiding


		popper.addEventListener('mouseenter', function () {
			if (instance.props.interactive && instance.state.isVisible) {
				instance.clearDelayTimeouts();
			}
		});
		popper.addEventListener('mouseleave', function () {
			if (instance.props.interactive && instance.props.trigger.indexOf('mouseenter') >= 0) {
				getDocument().addEventListener('mousemove', debouncedOnMouseMove);
			}
		});
		return instance; // ===========================================================================
		// 🔒 Private methods
		// ===========================================================================

		function getNormalizedTouchSettings() {
			var touch = instance.props.touch;
			return Array.isArray(touch) ? touch : [touch, 0];
		}

		function getIsCustomTouchBehavior() {
			return getNormalizedTouchSettings()[0] === 'hold';
		}

		function getIsDefaultRenderFn() {
			var _instance$props$rende;

			// @ts-ignore
			return !!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy);
		}

		function getCurrentTarget() {
			return currentTarget || reference;
		}

		function getDocument() {
			var parent = getCurrentTarget().parentNode;
			return parent ? getOwnerDocument(parent) : document;
		}

		function getDefaultTemplateChildren() {
			return getChildren(popper);
		}

		function getDelay(isShow) {
			// For touch or keyboard input, force `0` delay for UX reasons
			// Also if the instance is mounted but not visible (transitioning out),
			// ignore delay
			if (instance.state.isMounted && !instance.state.isVisible || currentInput.isTouch || lastTriggerEvent && lastTriggerEvent.type === 'focus') {
				return 0;
			}

			return getValueAtIndexOrReturn(instance.props.delay, isShow ? 0 : 1, defaultProps.delay);
		}

		function handleStyles(fromHide) {
			if (fromHide === void 0) {
				fromHide = false;
			}

			popper.style.pointerEvents = instance.props.interactive && !fromHide ? '' : 'none';
			popper.style.zIndex = "" + instance.props.zIndex;
		}

		function invokeHook(hook, args, shouldInvokePropsHook) {
			if (shouldInvokePropsHook === void 0) {
				shouldInvokePropsHook = true;
			}

			pluginsHooks.forEach(function (pluginHooks) {
				if (pluginHooks[hook]) {
					pluginHooks[hook].apply(pluginHooks, args);
				}
			});

			if (shouldInvokePropsHook) {
				var _instance$props;

				(_instance$props = instance.props)[hook].apply(_instance$props, args);
			}
		}

		function handleAriaContentAttribute() {
			var aria = instance.props.aria;

			if (!aria.content) {
				return;
			}

			var attr = "aria-" + aria.content;
			var id = popper.id;
			var nodes = normalizeToArray(instance.props.triggerTarget || reference);
			nodes.forEach(function (node) {
				var currentValue = node.getAttribute(attr);

				if (instance.state.isVisible) {
					node.setAttribute(attr, currentValue ? currentValue + " " + id : id);
				} else {
					var nextValue = currentValue && currentValue.replace(id, '').trim();

					if (nextValue) {
						node.setAttribute(attr, nextValue);
					} else {
						node.removeAttribute(attr);
					}
				}
			});
		}

		function handleAriaExpandedAttribute() {
			if (hasAriaExpanded || !instance.props.aria.expanded) {
				return;
			}

			var nodes = normalizeToArray(instance.props.triggerTarget || reference);
			nodes.forEach(function (node) {
				if (instance.props.interactive) {
					node.setAttribute('aria-expanded', instance.state.isVisible && node === getCurrentTarget() ? 'true' : 'false');
				} else {
					node.removeAttribute('aria-expanded');
				}
			});
		}

		function cleanupInteractiveMouseListeners() {
			getDocument().removeEventListener('mousemove', debouncedOnMouseMove);
			mouseMoveListeners = mouseMoveListeners.filter(function (listener) {
				return listener !== debouncedOnMouseMove;
			});
		}

		function onDocumentPress(event) {
			// Moved finger to scroll instead of an intentional tap outside
			if (currentInput.isTouch) {
				if (didTouchMove || event.type === 'mousedown') {
					return;
				}
			}

			var actualTarget = event.composedPath && event.composedPath()[0] || event.target; // Clicked on interactive popper

			if (instance.props.interactive && actualContains(popper, actualTarget)) {
				return;
			} // Clicked on the event listeners target


			if (normalizeToArray(instance.props.triggerTarget || reference).some(function (el) {
				return actualContains(el, actualTarget);
			})) {
				if (currentInput.isTouch) {
					return;
				}

				if (instance.state.isVisible && instance.props.trigger.indexOf('click') >= 0) {
					return;
				}
			} else {
				invokeHook('onClickOutside', [instance, event]);
			}

			if (instance.props.hideOnClick === true) {
				instance.clearDelayTimeouts();
				instance.hide(); // `mousedown` event is fired right before `focus` if pressing the
				// currentTarget. This lets a tippy with `focus` trigger know that it
				// should not show

				didHideDueToDocumentMouseDown = true;
				setTimeout(function () {
					didHideDueToDocumentMouseDown = false;
				}); // The listener gets added in `scheduleShow()`, but this may be hiding it
				// before it shows, and hide()'s early bail-out behavior can prevent it
				// from being cleaned up

				if (!instance.state.isMounted) {
					removeDocumentPress();
				}
			}
		}

		function onTouchMove() {
			didTouchMove = true;
		}

		function onTouchStart() {
			didTouchMove = false;
		}

		function addDocumentPress() {
			var doc = getDocument();
			doc.addEventListener('mousedown', onDocumentPress, true);
			doc.addEventListener('touchend', onDocumentPress, TOUCH_OPTIONS);
			doc.addEventListener('touchstart', onTouchStart, TOUCH_OPTIONS);
			doc.addEventListener('touchmove', onTouchMove, TOUCH_OPTIONS);
		}

		function removeDocumentPress() {
			var doc = getDocument();
			doc.removeEventListener('mousedown', onDocumentPress, true);
			doc.removeEventListener('touchend', onDocumentPress, TOUCH_OPTIONS);
			doc.removeEventListener('touchstart', onTouchStart, TOUCH_OPTIONS);
			doc.removeEventListener('touchmove', onTouchMove, TOUCH_OPTIONS);
		}

		function onTransitionedOut(duration, callback) {
			onTransitionEnd(duration, function () {
				if (!instance.state.isVisible && popper.parentNode && popper.parentNode.contains(popper)) {
					callback();
				}
			});
		}

		function onTransitionedIn(duration, callback) {
			onTransitionEnd(duration, callback);
		}

		function onTransitionEnd(duration, callback) {
			var box = getDefaultTemplateChildren().box;

			function listener(event) {
				if (event.target === box) {
					updateTransitionEndListener(box, 'remove', listener);
					callback();
				}
			} // Make callback synchronous if duration is 0
			// `transitionend` won't fire otherwise


			if (duration === 0) {
				return callback();
			}

			updateTransitionEndListener(box, 'remove', currentTransitionEndListener);
			updateTransitionEndListener(box, 'add', listener);
			currentTransitionEndListener = listener;
		}

		function on(eventType, handler, options) {
			if (options === void 0) {
				options = false;
			}

			var nodes = normalizeToArray(instance.props.triggerTarget || reference);
			nodes.forEach(function (node) {
				node.addEventListener(eventType, handler, options);
				listeners.push({
					node: node,
					eventType: eventType,
					handler: handler,
					options: options
				});
			});
		}

		function addListeners() {
			if (getIsCustomTouchBehavior()) {
				on('touchstart', onTrigger, {
					passive: true
				});
				on('touchend', onMouseLeave, {
					passive: true
				});
			}

			splitBySpaces(instance.props.trigger).forEach(function (eventType) {
				if (eventType === 'manual') {
					return;
				}

				on(eventType, onTrigger);

				switch (eventType) {
					case 'mouseenter':
						on('mouseleave', onMouseLeave);
						break;

					case 'focus':
						on(isIE11 ? 'focusout' : 'blur', onBlurOrFocusOut);
						break;

					case 'focusin':
						on('focusout', onBlurOrFocusOut);
						break;
				}
			});
		}

		function removeListeners() {
			listeners.forEach(function (_ref) {
				var node = _ref.node,
					eventType = _ref.eventType,
					handler = _ref.handler,
					options = _ref.options;
				node.removeEventListener(eventType, handler, options);
			});
			listeners = [];
		}

		function onTrigger(event) {
			var _lastTriggerEvent;

			var shouldScheduleClickHide = false;

			if (!instance.state.isEnabled || isEventListenerStopped(event) || didHideDueToDocumentMouseDown) {
				return;
			}

			var wasFocused = ((_lastTriggerEvent = lastTriggerEvent) == null ? void 0 : _lastTriggerEvent.type) === 'focus';
			lastTriggerEvent = event;
			currentTarget = event.currentTarget;
			handleAriaExpandedAttribute();

			if (!instance.state.isVisible && isMouseEvent(event)) {
				// If scrolling, `mouseenter` events can be fired if the cursor lands
				// over a new target, but `mousemove` events don't get fired. This
				// causes interactive tooltips to get stuck open until the cursor is
				// moved
				mouseMoveListeners.forEach(function (listener) {
					return listener(event);
				});
			} // Toggle show/hide when clicking click-triggered tooltips


			if (event.type === 'click' && (instance.props.trigger.indexOf('mouseenter') < 0 || isVisibleFromClick) && instance.props.hideOnClick !== false && instance.state.isVisible) {
				shouldScheduleClickHide = true;
			} else {
				scheduleShow(event);
			}

			if (event.type === 'click') {
				isVisibleFromClick = !shouldScheduleClickHide;
			}

			if (shouldScheduleClickHide && !wasFocused) {
				scheduleHide(event);
			}
		}

		function onMouseMove(event) {
			var target = event.target;
			var isCursorOverReferenceOrPopper = getCurrentTarget().contains(target) || popper.contains(target);

			if (event.type === 'mousemove' && isCursorOverReferenceOrPopper) {
				return;
			}

			var popperTreeData = getNestedPopperTree().concat(popper).map(function (popper) {
				var _instance$popperInsta;

				var instance = popper._tippy;
				var state = (_instance$popperInsta = instance.popperInstance) == null ? void 0 : _instance$popperInsta.state;

				if (state) {
					return {
						popperRect: popper.getBoundingClientRect(),
						popperState: state,
						props: props
					};
				}

				return null;
			}).filter(Boolean);

			if (isCursorOutsideInteractiveBorder(popperTreeData, event)) {
				cleanupInteractiveMouseListeners();
				scheduleHide(event);
			}
		}

		function onMouseLeave(event) {
			var shouldBail = isEventListenerStopped(event) || instance.props.trigger.indexOf('click') >= 0 && isVisibleFromClick;

			if (shouldBail) {
				return;
			}

			if (instance.props.interactive) {
				instance.hideWithInteractivity(event);
				return;
			}

			scheduleHide(event);
		}

		function onBlurOrFocusOut(event) {
			if (instance.props.trigger.indexOf('focusin') < 0 && event.target !== getCurrentTarget()) {
				return;
			} // If focus was moved to within the popper


			if (instance.props.interactive && event.relatedTarget && popper.contains(event.relatedTarget)) {
				return;
			}

			scheduleHide(event);
		}

		function isEventListenerStopped(event) {
			return currentInput.isTouch ? getIsCustomTouchBehavior() !== event.type.indexOf('touch') >= 0 : false;
		}

		function createPopperInstance() {
			destroyPopperInstance();
			var _instance$props2 = instance.props,
				popperOptions = _instance$props2.popperOptions,
				placement = _instance$props2.placement,
				offset = _instance$props2.offset,
				getReferenceClientRect = _instance$props2.getReferenceClientRect,
				moveTransition = _instance$props2.moveTransition;
			var arrow = getIsDefaultRenderFn() ? getChildren(popper).arrow : null;
			var computedReference = getReferenceClientRect ? {
				getBoundingClientRect: getReferenceClientRect,
				contextElement: getReferenceClientRect.contextElement || getCurrentTarget()
			} : reference;
			var tippyModifier = {
				name: '$$tippy',
				enabled: true,
				phase: 'beforeWrite',
				requires: ['computeStyles'],
				fn: function fn(_ref2) {
					var state = _ref2.state;

					if (getIsDefaultRenderFn()) {
						var _getDefaultTemplateCh = getDefaultTemplateChildren(),
							box = _getDefaultTemplateCh.box;

						['placement', 'reference-hidden', 'escaped'].forEach(function (attr) {
							if (attr === 'placement') {
								box.setAttribute('data-placement', state.placement);
							} else {
								if (state.attributes.popper["data-popper-" + attr]) {
									box.setAttribute("data-" + attr, '');
								} else {
									box.removeAttribute("data-" + attr);
								}
							}
						});
						state.attributes.popper = {};
					}
				}
			};
			var modifiers = [{
				name: 'offset',
				options: {
					offset: offset
				}
			}, {
				name: 'preventOverflow',
				options: {
					padding: {
						top: 2,
						bottom: 2,
						left: 5,
						right: 5
					}
				}
			}, {
				name: 'flip',
				options: {
					padding: 5
				}
			}, {
				name: 'computeStyles',
				options: {
					adaptive: !moveTransition
				}
			}, tippyModifier];

			if (getIsDefaultRenderFn() && arrow) {
				modifiers.push({
					name: 'arrow',
					options: {
						element: arrow,
						padding: 3
					}
				});
			}

			modifiers.push.apply(modifiers, (popperOptions == null ? void 0 : popperOptions.modifiers) || []);
			instance.popperInstance = core.createPopper(computedReference, popper, Object.assign({}, popperOptions, {
				placement: placement,
				onFirstUpdate: onFirstUpdate,
				modifiers: modifiers
			}));
		}

		function destroyPopperInstance() {
			if (instance.popperInstance) {
				instance.popperInstance.destroy();
				instance.popperInstance = null;
			}
		}

		function mount() {
			var appendTo = instance.props.appendTo;
			var parentNode; // By default, we'll append the popper to the triggerTargets's parentNode so
			// it's directly after the reference element so the elements inside the
			// tippy can be tabbed to
			// If there are clipping issues, the user can specify a different appendTo
			// and ensure focus management is handled correctly manually

			var node = getCurrentTarget();

			if (instance.props.interactive && appendTo === TIPPY_DEFAULT_APPEND_TO || appendTo === 'parent') {
				parentNode = node.parentNode;
			} else {
				parentNode = invokeWithArgsOrReturn(appendTo, [node]);
			} // The popper element needs to exist on the DOM before its position can be
			// updated as Popper needs to read its dimensions


			if (!parentNode.contains(popper)) {
				parentNode.appendChild(popper);
			}

			instance.state.isMounted = true;
			createPopperInstance();
			/* istanbul ignore else */

			{
				// Accessibility check
				warnWhen(instance.props.interactive && appendTo === defaultProps.appendTo && node.nextElementSibling !== popper, ['Interactive tippy element may not be accessible via keyboard', 'navigation because it is not directly after the reference element', 'in the DOM source order.', '\n\n', 'Using a wrapper <div> or <span> tag around the reference element', 'solves this by creating a new parentNode context.', '\n\n', 'Specifying `appendTo: document.body` silences this warning, but it', 'assumes you are using a focus management solution to handle', 'keyboard navigation.', '\n\n', 'See: https://atomiks.github.io/tippyjs/v6/accessibility/#interactivity'].join(' '));
			}
		}

		function getNestedPopperTree() {
			return arrayFrom(popper.querySelectorAll('[data-tippy-root]'));
		}

		function scheduleShow(event) {
			instance.clearDelayTimeouts();

			if (event) {
				invokeHook('onTrigger', [instance, event]);
			}

			addDocumentPress();
			var delay = getDelay(true);

			var _getNormalizedTouchSe = getNormalizedTouchSettings(),
				touchValue = _getNormalizedTouchSe[0],
				touchDelay = _getNormalizedTouchSe[1];

			if (currentInput.isTouch && touchValue === 'hold' && touchDelay) {
				delay = touchDelay;
			}

			if (delay) {
				showTimeout = setTimeout(function () {
					instance.show();
				}, delay);
			} else {
				instance.show();
			}
		}

		function scheduleHide(event) {
			instance.clearDelayTimeouts();
			invokeHook('onUntrigger', [instance, event]);

			if (!instance.state.isVisible) {
				removeDocumentPress();
				return;
			} // For interactive tippies, scheduleHide is added to a document.body handler
			// from onMouseLeave so must intercept scheduled hides from mousemove/leave
			// events when trigger contains mouseenter and click, and the tip is
			// currently shown as a result of a click.


			if (instance.props.trigger.indexOf('mouseenter') >= 0 && instance.props.trigger.indexOf('click') >= 0 && ['mouseleave', 'mousemove'].indexOf(event.type) >= 0 && isVisibleFromClick) {
				return;
			}

			var delay = getDelay(false);

			if (delay) {
				hideTimeout = setTimeout(function () {
					if (instance.state.isVisible) {
						instance.hide();
					}
				}, delay);
			} else {
				// Fixes a `transitionend` problem when it fires 1 frame too
				// late sometimes, we don't want hide() to be called.
				scheduleHideAnimationFrame = requestAnimationFrame(function () {
					instance.hide();
				});
			}
		} // ===========================================================================
		// 🔑 Public methods
		// ===========================================================================


		function enable() {
			instance.state.isEnabled = true;
		}

		function disable() {
			// Disabling the instance should also hide it
			// https://github.com/atomiks/tippy.js-react/issues/106
			instance.hide();
			instance.state.isEnabled = false;
		}

		function clearDelayTimeouts() {
			clearTimeout(showTimeout);
			clearTimeout(hideTimeout);
			cancelAnimationFrame(scheduleHideAnimationFrame);
		}

		function setProps(partialProps) {
			/* istanbul ignore else */
			{
				warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('setProps'));
			}

			if (instance.state.isDestroyed) {
				return;
			}

			invokeHook('onBeforeUpdate', [instance, partialProps]);
			removeListeners();
			var prevProps = instance.props;
			var nextProps = evaluateProps(reference, Object.assign({}, prevProps, removeUndefinedProps(partialProps), {
				ignoreAttributes: true
			}));
			instance.props = nextProps;
			addListeners();

			if (prevProps.interactiveDebounce !== nextProps.interactiveDebounce) {
				cleanupInteractiveMouseListeners();
				debouncedOnMouseMove = debounce(onMouseMove, nextProps.interactiveDebounce);
			} // Ensure stale aria-expanded attributes are removed


			if (prevProps.triggerTarget && !nextProps.triggerTarget) {
				normalizeToArray(prevProps.triggerTarget).forEach(function (node) {
					node.removeAttribute('aria-expanded');
				});
			} else if (nextProps.triggerTarget) {
				reference.removeAttribute('aria-expanded');
			}

			handleAriaExpandedAttribute();
			handleStyles();

			if (onUpdate) {
				onUpdate(prevProps, nextProps);
			}

			if (instance.popperInstance) {
				createPopperInstance(); // Fixes an issue with nested tippies if they are all getting re-rendered,
				// and the nested ones get re-rendered first.
				// https://github.com/atomiks/tippyjs-react/issues/177
				// TODO: find a cleaner / more efficient solution(!)

				getNestedPopperTree().forEach(function (nestedPopper) {
					// React (and other UI libs likely) requires a rAF wrapper as it flushes
					// its work in one
					requestAnimationFrame(nestedPopper._tippy.popperInstance.forceUpdate);
				});
			}

			invokeHook('onAfterUpdate', [instance, partialProps]);
		}

		function setContent(content) {
			instance.setProps({
				content: content
			});
		}

		function show() {
			/* istanbul ignore else */
			{
				warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('show'));
			} // Early bail-out


			var isAlreadyVisible = instance.state.isVisible;
			var isDestroyed = instance.state.isDestroyed;
			var isDisabled = !instance.state.isEnabled;
			var isTouchAndTouchDisabled = currentInput.isTouch && !instance.props.touch;
			var duration = getValueAtIndexOrReturn(instance.props.duration, 0, defaultProps.duration);

			if (isAlreadyVisible || isDestroyed || isDisabled || isTouchAndTouchDisabled) {
				return;
			} // Normalize `disabled` behavior across browsers.
			// Firefox allows events on disabled elements, but Chrome doesn't.
			// Using a wrapper element (i.e. <span>) is recommended.


			if (getCurrentTarget().hasAttribute('disabled')) {
				return;
			}

			invokeHook('onShow', [instance], false);

			if (instance.props.onShow(instance) === false) {
				return;
			}

			instance.state.isVisible = true;

			if (getIsDefaultRenderFn()) {
				popper.style.visibility = 'visible';
			}

			handleStyles();
			addDocumentPress();

			if (!instance.state.isMounted) {
				popper.style.transition = 'none';
			} // If flipping to the opposite side after hiding at least once, the
			// animation will use the wrong placement without resetting the duration


			if (getIsDefaultRenderFn()) {
				var _getDefaultTemplateCh2 = getDefaultTemplateChildren(),
					box = _getDefaultTemplateCh2.box,
					content = _getDefaultTemplateCh2.content;

				setTransitionDuration([box, content], 0);
			}

			onFirstUpdate = function onFirstUpdate() {
				var _instance$popperInsta2;

				if (!instance.state.isVisible || ignoreOnFirstUpdate) {
					return;
				}

				ignoreOnFirstUpdate = true; // reflow

				void popper.offsetHeight;
				popper.style.transition = instance.props.moveTransition;

				if (getIsDefaultRenderFn() && instance.props.animation) {
					var _getDefaultTemplateCh3 = getDefaultTemplateChildren(),
						_box = _getDefaultTemplateCh3.box,
						_content = _getDefaultTemplateCh3.content;

					setTransitionDuration([_box, _content], duration);
					setVisibilityState([_box, _content], 'visible');
				}

				handleAriaContentAttribute();
				handleAriaExpandedAttribute();
				pushIfUnique(mountedInstances, instance); // certain modifiers (e.g. `maxSize`) require a second update after the
				// popper has been positioned for the first time

				(_instance$popperInsta2 = instance.popperInstance) == null ? void 0 : _instance$popperInsta2.forceUpdate();
				invokeHook('onMount', [instance]);

				if (instance.props.animation && getIsDefaultRenderFn()) {
					onTransitionedIn(duration, function () {
						instance.state.isShown = true;
						invokeHook('onShown', [instance]);
					});
				}
			};

			mount();
		}

		function hide() {
			/* istanbul ignore else */
			{
				warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('hide'));
			} // Early bail-out


			var isAlreadyHidden = !instance.state.isVisible;
			var isDestroyed = instance.state.isDestroyed;
			var isDisabled = !instance.state.isEnabled;
			var duration = getValueAtIndexOrReturn(instance.props.duration, 1, defaultProps.duration);

			if (isAlreadyHidden || isDestroyed || isDisabled) {
				return;
			}

			invokeHook('onHide', [instance], false);

			if (instance.props.onHide(instance) === false) {
				return;
			}

			instance.state.isVisible = false;
			instance.state.isShown = false;
			ignoreOnFirstUpdate = false;
			isVisibleFromClick = false;

			if (getIsDefaultRenderFn()) {
				popper.style.visibility = 'hidden';
			}

			cleanupInteractiveMouseListeners();
			removeDocumentPress();
			handleStyles(true);

			if (getIsDefaultRenderFn()) {
				var _getDefaultTemplateCh4 = getDefaultTemplateChildren(),
					box = _getDefaultTemplateCh4.box,
					content = _getDefaultTemplateCh4.content;

				if (instance.props.animation) {
					setTransitionDuration([box, content], duration);
					setVisibilityState([box, content], 'hidden');
				}
			}

			handleAriaContentAttribute();
			handleAriaExpandedAttribute();

			if (instance.props.animation) {
				if (getIsDefaultRenderFn()) {
					onTransitionedOut(duration, instance.unmount);
				}
			} else {
				instance.unmount();
			}
		}

		function hideWithInteractivity(event) {
			/* istanbul ignore else */
			{
				warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('hideWithInteractivity'));
			}

			getDocument().addEventListener('mousemove', debouncedOnMouseMove);
			pushIfUnique(mouseMoveListeners, debouncedOnMouseMove);
			debouncedOnMouseMove(event);
		}

		function unmount() {
			/* istanbul ignore else */
			{
				warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('unmount'));
			}

			if (instance.state.isVisible) {
				instance.hide();
			}

			if (!instance.state.isMounted) {
				return;
			}

			destroyPopperInstance(); // If a popper is not interactive, it will be appended outside the popper
			// tree by default. This seems mainly for interactive tippies, but we should
			// find a workaround if possible

			getNestedPopperTree().forEach(function (nestedPopper) {
				nestedPopper._tippy.unmount();
			});

			if (popper.parentNode) {
				popper.parentNode.removeChild(popper);
			}

			mountedInstances = mountedInstances.filter(function (i) {
				return i !== instance;
			});
			instance.state.isMounted = false;
			invokeHook('onHidden', [instance]);
		}

		function destroy() {
			/* istanbul ignore else */
			{
				warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('destroy'));
			}

			if (instance.state.isDestroyed) {
				return;
			}

			instance.clearDelayTimeouts();
			instance.unmount();
			removeListeners();
			delete reference._tippy;
			instance.state.isDestroyed = true;
			invokeHook('onDestroy', [instance]);
		}
	}

	function tippy(targets, optionalProps) {
		if (optionalProps === void 0) {
			optionalProps = {};
		}

		var plugins = defaultProps.plugins.concat(optionalProps.plugins || []);
		/* istanbul ignore else */

		{
			validateTargets(targets);
			validateProps(optionalProps, plugins);
		}

		bindGlobalEventListeners();
		var passedProps = Object.assign({}, optionalProps, {
			plugins: plugins
		});
		var elements = getArrayOfElements(targets);
		/* istanbul ignore else */

		{
			var isSingleContentElement = isElement(passedProps.content);
			var isMoreThanOneReferenceElement = elements.length > 1;
			warnWhen(isSingleContentElement && isMoreThanOneReferenceElement, ['tippy() was passed an Element as the `content` prop, but more than', 'one tippy instance was created by this invocation. This means the', 'content element will only be appended to the last tippy instance.', '\n\n', 'Instead, pass the .innerHTML of the element, or use a function that', 'returns a cloned version of the element instead.', '\n\n', '1) content: element.innerHTML\n', '2) content: () => element.cloneNode(true)'].join(' '));
		}

		var instances = elements.reduce(function (acc, reference) {
			var instance = reference && createTippy(reference, passedProps);

			if (instance) {
				acc.push(instance);
			}

			return acc;
		}, []);
		return isElement(targets) ? instances[0] : instances;
	}

	tippy.defaultProps = defaultProps;
	tippy.setDefaultProps = setDefaultProps;
	tippy.currentInput = currentInput;
	var hideAll = function hideAll(_temp) {
		var _ref = _temp === void 0 ? {} : _temp,
			excludedReferenceOrInstance = _ref.exclude,
			duration = _ref.duration;

		mountedInstances.forEach(function (instance) {
			var isExcluded = false;

			if (excludedReferenceOrInstance) {
				isExcluded = isReferenceElement(excludedReferenceOrInstance) ? instance.reference === excludedReferenceOrInstance : instance.popper === excludedReferenceOrInstance.popper;
			}

			if (!isExcluded) {
				var originalDuration = instance.props.duration;
				instance.setProps({
					duration: duration
				});
				instance.hide();

				if (!instance.state.isDestroyed) {
					instance.setProps({
						duration: originalDuration
					});
				}
			}
		});
	};

	// every time the popper is destroyed (i.e. a new target), removing the styles
	// and causing transitions to break for singletons when the console is open, but
	// most notably for non-transform styles being used, `gpuAcceleration: false`.

	var applyStylesModifier = Object.assign({}, core.applyStyles, {
		effect: function effect(_ref) {
			var state = _ref.state;
			var initialStyles = {
				popper: {
					position: state.options.strategy,
					left: '0',
					top: '0',
					margin: '0'
				},
				arrow: {
					position: 'absolute'
				},
				reference: {}
			};
			Object.assign(state.elements.popper.style, initialStyles.popper);
			state.styles = initialStyles;

			if (state.elements.arrow) {
				Object.assign(state.elements.arrow.style, initialStyles.arrow);
			} // intentionally return no cleanup function
			// return () => { ... }

		}
	});

	var createSingleton = function createSingleton(tippyInstances, optionalProps) {
		var _optionalProps$popper;

		if (optionalProps === void 0) {
			optionalProps = {};
		}

		/* istanbul ignore else */
		{
			errorWhen(!Array.isArray(tippyInstances), ['The first argument passed to createSingleton() must be an array of', 'tippy instances. The passed value was', String(tippyInstances)].join(' '));
		}

		var individualInstances = tippyInstances;
		var references = [];
		var triggerTargets = [];
		var currentTarget;
		var overrides = optionalProps.overrides;
		var interceptSetPropsCleanups = [];
		var shownOnCreate = false;

		function setTriggerTargets() {
			triggerTargets = individualInstances.map(function (instance) {
				return normalizeToArray(instance.props.triggerTarget || instance.reference);
			}).reduce(function (acc, item) {
				return acc.concat(item);
			}, []);
		}

		function setReferences() {
			references = individualInstances.map(function (instance) {
				return instance.reference;
			});
		}

		function enableInstances(isEnabled) {
			individualInstances.forEach(function (instance) {
				if (isEnabled) {
					instance.enable();
				} else {
					instance.disable();
				}
			});
		}

		function interceptSetProps(singleton) {
			return individualInstances.map(function (instance) {
				var originalSetProps = instance.setProps;

				instance.setProps = function (props) {
					originalSetProps(props);

					if (instance.reference === currentTarget) {
						singleton.setProps(props);
					}
				};

				return function () {
					instance.setProps = originalSetProps;
				};
			});
		} // have to pass singleton, as it maybe undefined on first call


		function prepareInstance(singleton, target) {
			var index = triggerTargets.indexOf(target); // bail-out

			if (target === currentTarget) {
				return;
			}

			currentTarget = target;
			var overrideProps = (overrides || []).concat('content').reduce(function (acc, prop) {
				acc[prop] = individualInstances[index].props[prop];
				return acc;
			}, {});
			singleton.setProps(Object.assign({}, overrideProps, {
				getReferenceClientRect: typeof overrideProps.getReferenceClientRect === 'function' ? overrideProps.getReferenceClientRect : function () {
					var _references$index;

					return (_references$index = references[index]) == null ? void 0 : _references$index.getBoundingClientRect();
				}
			}));
		}

		enableInstances(false);
		setReferences();
		setTriggerTargets();
		var plugin = {
			fn: function fn() {
				return {
					onDestroy: function onDestroy() {
						enableInstances(true);
					},
					onHidden: function onHidden() {
						currentTarget = null;
					},
					onClickOutside: function onClickOutside(instance) {
						if (instance.props.showOnCreate && !shownOnCreate) {
							shownOnCreate = true;
							currentTarget = null;
						}
					},
					onShow: function onShow(instance) {
						if (instance.props.showOnCreate && !shownOnCreate) {
							shownOnCreate = true;
							prepareInstance(instance, references[0]);
						}
					},
					onTrigger: function onTrigger(instance, event) {
						prepareInstance(instance, event.currentTarget);
					}
				};
			}
		};
		var singleton = tippy(div(), Object.assign({}, removeProperties(optionalProps, ['overrides']), {
			plugins: [plugin].concat(optionalProps.plugins || []),
			triggerTarget: triggerTargets,
			popperOptions: Object.assign({}, optionalProps.popperOptions, {
				modifiers: [].concat(((_optionalProps$popper = optionalProps.popperOptions) == null ? void 0 : _optionalProps$popper.modifiers) || [], [applyStylesModifier])
			})
		}));
		var originalShow = singleton.show;

		singleton.show = function (target) {
			originalShow(); // first time, showOnCreate or programmatic call with no params
			// default to showing first instance

			if (!currentTarget && target == null) {
				return prepareInstance(singleton, references[0]);
			} // triggered from event (do nothing as prepareInstance already called by onTrigger)
			// programmatic call with no params when already visible (do nothing again)


			if (currentTarget && target == null) {
				return;
			} // target is index of instance


			if (typeof target === 'number') {
				return references[target] && prepareInstance(singleton, references[target]);
			} // target is a child tippy instance


			if (individualInstances.indexOf(target) >= 0) {
				var ref = target.reference;
				return prepareInstance(singleton, ref);
			} // target is a ReferenceElement


			if (references.indexOf(target) >= 0) {
				return prepareInstance(singleton, target);
			}
		};

		singleton.showNext = function () {
			var first = references[0];

			if (!currentTarget) {
				return singleton.show(0);
			}

			var index = references.indexOf(currentTarget);
			singleton.show(references[index + 1] || first);
		};

		singleton.showPrevious = function () {
			var last = references[references.length - 1];

			if (!currentTarget) {
				return singleton.show(last);
			}

			var index = references.indexOf(currentTarget);
			var target = references[index - 1] || last;
			singleton.show(target);
		};

		var originalSetProps = singleton.setProps;

		singleton.setProps = function (props) {
			overrides = props.overrides || overrides;
			originalSetProps(props);
		};

		singleton.setInstances = function (nextInstances) {
			enableInstances(true);
			interceptSetPropsCleanups.forEach(function (fn) {
				return fn();
			});
			individualInstances = nextInstances;
			enableInstances(false);
			setReferences();
			setTriggerTargets();
			interceptSetPropsCleanups = interceptSetProps(singleton);
			singleton.setProps({
				triggerTarget: triggerTargets
			});
		};

		interceptSetPropsCleanups = interceptSetProps(singleton);
		return singleton;
	};

	var BUBBLING_EVENTS_MAP = {
		mouseover: 'mouseenter',
		focusin: 'focus',
		click: 'click'
	};
	/**
	 * Creates a delegate instance that controls the creation of tippy instances
	 * for child elements (`target` CSS selector).
	 */

	function delegate(targets, props) {
		/* istanbul ignore else */
		{
			errorWhen(!(props && props.target), ['You must specity a `target` prop indicating a CSS selector string matching', 'the target elements that should receive a tippy.'].join(' '));
		}

		var listeners = [];
		var childTippyInstances = [];
		var disabled = false;
		var target = props.target;
		var nativeProps = removeProperties(props, ['target']);
		var parentProps = Object.assign({}, nativeProps, {
			trigger: 'manual',
			touch: false
		});
		var childProps = Object.assign({
			touch: defaultProps.touch
		}, nativeProps, {
			showOnCreate: true
		});
		var returnValue = tippy(targets, parentProps);
		var normalizedReturnValue = normalizeToArray(returnValue);

		function onTrigger(event) {
			if (!event.target || disabled) {
				return;
			}

			var targetNode = event.target.closest(target);

			if (!targetNode) {
				return;
			} // Get relevant trigger with fallbacks:
			// 1. Check `data-tippy-trigger` attribute on target node
			// 2. Fallback to `trigger` passed to `delegate()`
			// 3. Fallback to `defaultProps.trigger`


			var trigger = targetNode.getAttribute('data-tippy-trigger') || props.trigger || defaultProps.trigger; // @ts-ignore

			if (targetNode._tippy) {
				return;
			}

			if (event.type === 'touchstart' && typeof childProps.touch === 'boolean') {
				return;
			}

			if (event.type !== 'touchstart' && trigger.indexOf(BUBBLING_EVENTS_MAP[event.type]) < 0) {
				return;
			}

			var instance = tippy(targetNode, childProps);

			if (instance) {
				childTippyInstances = childTippyInstances.concat(instance);
			}
		}

		function on(node, eventType, handler, options) {
			if (options === void 0) {
				options = false;
			}

			node.addEventListener(eventType, handler, options);
			listeners.push({
				node: node,
				eventType: eventType,
				handler: handler,
				options: options
			});
		}

		function addEventListeners(instance) {
			var reference = instance.reference;
			on(reference, 'touchstart', onTrigger, TOUCH_OPTIONS);
			on(reference, 'mouseover', onTrigger);
			on(reference, 'focusin', onTrigger);
			on(reference, 'click', onTrigger);
		}

		function removeEventListeners() {
			listeners.forEach(function (_ref) {
				var node = _ref.node,
					eventType = _ref.eventType,
					handler = _ref.handler,
					options = _ref.options;
				node.removeEventListener(eventType, handler, options);
			});
			listeners = [];
		}

		function applyMutations(instance) {
			var originalDestroy = instance.destroy;
			var originalEnable = instance.enable;
			var originalDisable = instance.disable;

			instance.destroy = function (shouldDestroyChildInstances) {
				if (shouldDestroyChildInstances === void 0) {
					shouldDestroyChildInstances = true;
				}

				if (shouldDestroyChildInstances) {
					childTippyInstances.forEach(function (instance) {
						instance.destroy();
					});
				}

				childTippyInstances = [];
				removeEventListeners();
				originalDestroy();
			};

			instance.enable = function () {
				originalEnable();
				childTippyInstances.forEach(function (instance) {
					return instance.enable();
				});
				disabled = false;
			};

			instance.disable = function () {
				originalDisable();
				childTippyInstances.forEach(function (instance) {
					return instance.disable();
				});
				disabled = true;
			};

			addEventListeners(instance);
		}

		normalizedReturnValue.forEach(applyMutations);
		return returnValue;
	}

	var animateFill = {
		name: 'animateFill',
		defaultValue: false,
		fn: function fn(instance) {
			var _instance$props$rende;

			// @ts-ignore
			if (!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy)) {
				{
					errorWhen(instance.props.animateFill, 'The `animateFill` plugin requires the default render function.');
				}

				return {};
			}

			var _getChildren = getChildren(instance.popper),
				box = _getChildren.box,
				content = _getChildren.content;

			var backdrop = instance.props.animateFill ? createBackdropElement() : null;
			return {
				onCreate: function onCreate() {
					if (backdrop) {
						box.insertBefore(backdrop, box.firstElementChild);
						box.setAttribute('data-animatefill', '');
						box.style.overflow = 'hidden';
						instance.setProps({
							arrow: false,
							animation: 'shift-away'
						});
					}
				},
				onMount: function onMount() {
					if (backdrop) {
						var transitionDuration = box.style.transitionDuration;
						var duration = Number(transitionDuration.replace('ms', '')); // The content should fade in after the backdrop has mostly filled the
						// tooltip element. `clip-path` is the other alternative but is not
						// well-supported and is buggy on some devices.

						content.style.transitionDelay = Math.round(duration / 10) + "ms";
						backdrop.style.transitionDuration = transitionDuration;
						setVisibilityState([backdrop], 'visible');
					}
				},
				onShow: function onShow() {
					if (backdrop) {
						backdrop.style.transitionDuration = '0ms';
					}
				},
				onHide: function onHide() {
					if (backdrop) {
						setVisibilityState([backdrop], 'hidden');
					}
				}
			};
		}
	};

	function createBackdropElement() {
		var backdrop = div();
		backdrop.className = BACKDROP_CLASS;
		setVisibilityState([backdrop], 'hidden');
		return backdrop;
	}

	var mouseCoords = {
		clientX: 0,
		clientY: 0
	};
	var activeInstances = [];

	function storeMouseCoords(_ref) {
		var clientX = _ref.clientX,
			clientY = _ref.clientY;
		mouseCoords = {
			clientX: clientX,
			clientY: clientY
		};
	}

	function addMouseCoordsListener(doc) {
		doc.addEventListener('mousemove', storeMouseCoords);
	}

	function removeMouseCoordsListener(doc) {
		doc.removeEventListener('mousemove', storeMouseCoords);
	}

	var followCursor = {
		name: 'followCursor',
		defaultValue: false,
		fn: function fn(instance) {
			var reference = instance.reference;
			var doc = getOwnerDocument(instance.props.triggerTarget || reference);
			var isInternalUpdate = false;
			var wasFocusEvent = false;
			var isUnmounted = true;
			var prevProps = instance.props;

			function getIsInitialBehavior() {
				return instance.props.followCursor === 'initial' && instance.state.isVisible;
			}

			function addListener() {
				doc.addEventListener('mousemove', onMouseMove);
			}

			function removeListener() {
				doc.removeEventListener('mousemove', onMouseMove);
			}

			function unsetGetReferenceClientRect() {
				isInternalUpdate = true;
				instance.setProps({
					getReferenceClientRect: null
				});
				isInternalUpdate = false;
			}

			function onMouseMove(event) {
				// If the instance is interactive, avoid updating the position unless it's
				// over the reference element
				var isCursorOverReference = event.target ? reference.contains(event.target) : true;
				var followCursor = instance.props.followCursor;
				var clientX = event.clientX,
					clientY = event.clientY;
				var rect = reference.getBoundingClientRect();
				var relativeX = clientX - rect.left;
				var relativeY = clientY - rect.top;

				if (isCursorOverReference || !instance.props.interactive) {
					instance.setProps({
						// @ts-ignore - unneeded DOMRect properties
						getReferenceClientRect: function getReferenceClientRect() {
							var rect = reference.getBoundingClientRect();
							var x = clientX;
							var y = clientY;

							if (followCursor === 'initial') {
								x = rect.left + relativeX;
								y = rect.top + relativeY;
							}

							var top = followCursor === 'horizontal' ? rect.top : y;
							var right = followCursor === 'vertical' ? rect.right : x;
							var bottom = followCursor === 'horizontal' ? rect.bottom : y;
							var left = followCursor === 'vertical' ? rect.left : x;
							return {
								width: right - left,
								height: bottom - top,
								top: top,
								right: right,
								bottom: bottom,
								left: left
							};
						}
					});
				}
			}

			function create() {
				if (instance.props.followCursor) {
					activeInstances.push({
						instance: instance,
						doc: doc
					});
					addMouseCoordsListener(doc);
				}
			}

			function destroy() {
				activeInstances = activeInstances.filter(function (data) {
					return data.instance !== instance;
				});

				if (activeInstances.filter(function (data) {
					return data.doc === doc;
				}).length === 0) {
					removeMouseCoordsListener(doc);
				}
			}

			return {
				onCreate: create,
				onDestroy: destroy,
				onBeforeUpdate: function onBeforeUpdate() {
					prevProps = instance.props;
				},
				onAfterUpdate: function onAfterUpdate(_, _ref2) {
					var followCursor = _ref2.followCursor;

					if (isInternalUpdate) {
						return;
					}

					if (followCursor !== undefined && prevProps.followCursor !== followCursor) {
						destroy();

						if (followCursor) {
							create();

							if (instance.state.isMounted && !wasFocusEvent && !getIsInitialBehavior()) {
								addListener();
							}
						} else {
							removeListener();
							unsetGetReferenceClientRect();
						}
					}
				},
				onMount: function onMount() {
					if (instance.props.followCursor && !wasFocusEvent) {
						if (isUnmounted) {
							onMouseMove(mouseCoords);
							isUnmounted = false;
						}

						if (!getIsInitialBehavior()) {
							addListener();
						}
					}
				},
				onTrigger: function onTrigger(_, event) {
					if (isMouseEvent(event)) {
						mouseCoords = {
							clientX: event.clientX,
							clientY: event.clientY
						};
					}

					wasFocusEvent = event.type === 'focus';
				},
				onHidden: function onHidden() {
					if (instance.props.followCursor) {
						unsetGetReferenceClientRect();
						removeListener();
						isUnmounted = true;
					}
				}
			};
		}
	};

	function getProps(props, modifier) {
		var _props$popperOptions;

		return {
			popperOptions: Object.assign({}, props.popperOptions, {
				modifiers: [].concat((((_props$popperOptions = props.popperOptions) == null ? void 0 : _props$popperOptions.modifiers) || []).filter(function (_ref) {
					var name = _ref.name;
					return name !== modifier.name;
				}), [modifier])
			})
		};
	}

	var inlinePositioning = {
		name: 'inlinePositioning',
		defaultValue: false,
		fn: function fn(instance) {
			var reference = instance.reference;

			function isEnabled() {
				return !!instance.props.inlinePositioning;
			}

			var placement;
			var cursorRectIndex = -1;
			var isInternalUpdate = false;
			var triedPlacements = [];
			var modifier = {
				name: 'tippyInlinePositioning',
				enabled: true,
				phase: 'afterWrite',
				fn: function fn(_ref2) {
					var state = _ref2.state;

					if (isEnabled()) {
						if (triedPlacements.indexOf(state.placement) !== -1) {
							triedPlacements = [];
						}

						if (placement !== state.placement && triedPlacements.indexOf(state.placement) === -1) {
							triedPlacements.push(state.placement);
							instance.setProps({
								// @ts-ignore - unneeded DOMRect properties
								getReferenceClientRect: function getReferenceClientRect() {
									return _getReferenceClientRect(state.placement);
								}
							});
						}

						placement = state.placement;
					}
				}
			};

			function _getReferenceClientRect(placement) {
				return getInlineBoundingClientRect(getBasePlacement(placement), reference.getBoundingClientRect(), arrayFrom(reference.getClientRects()), cursorRectIndex);
			}

			function setInternalProps(partialProps) {
				isInternalUpdate = true;
				instance.setProps(partialProps);
				isInternalUpdate = false;
			}

			function addModifier() {
				if (!isInternalUpdate) {
					setInternalProps(getProps(instance.props, modifier));
				}
			}

			return {
				onCreate: addModifier,
				onAfterUpdate: addModifier,
				onTrigger: function onTrigger(_, event) {
					if (isMouseEvent(event)) {
						var rects = arrayFrom(instance.reference.getClientRects());
						var cursorRect = rects.find(function (rect) {
							return rect.left - 2 <= event.clientX && rect.right + 2 >= event.clientX && rect.top - 2 <= event.clientY && rect.bottom + 2 >= event.clientY;
						});
						var index = rects.indexOf(cursorRect);
						cursorRectIndex = index > -1 ? index : cursorRectIndex;
					}
				},
				onHidden: function onHidden() {
					cursorRectIndex = -1;
				}
			};
		}
	};
	function getInlineBoundingClientRect(currentBasePlacement, boundingRect, clientRects, cursorRectIndex) {
		// Not an inline element, or placement is not yet known
		if (clientRects.length < 2 || currentBasePlacement === null) {
			return boundingRect;
		} // There are two rects and they are disjoined


		if (clientRects.length === 2 && cursorRectIndex >= 0 && clientRects[0].left > clientRects[1].right) {
			return clientRects[cursorRectIndex] || boundingRect;
		}

		switch (currentBasePlacement) {
			case 'top':
			case 'bottom':
			{
				var firstRect = clientRects[0];
				var lastRect = clientRects[clientRects.length - 1];
				var isTop = currentBasePlacement === 'top';
				var top = firstRect.top;
				var bottom = lastRect.bottom;
				var left = isTop ? firstRect.left : lastRect.left;
				var right = isTop ? firstRect.right : lastRect.right;
				var width = right - left;
				var height = bottom - top;
				return {
					top: top,
					bottom: bottom,
					left: left,
					right: right,
					width: width,
					height: height
				};
			}

			case 'left':
			case 'right':
			{
				var minLeft = Math.min.apply(Math, clientRects.map(function (rects) {
					return rects.left;
				}));
				var maxRight = Math.max.apply(Math, clientRects.map(function (rects) {
					return rects.right;
				}));
				var measureRects = clientRects.filter(function (rect) {
					return currentBasePlacement === 'left' ? rect.left === minLeft : rect.right === maxRight;
				});
				var _top = measureRects[0].top;
				var _bottom = measureRects[measureRects.length - 1].bottom;
				var _left = minLeft;
				var _right = maxRight;

				var _width = _right - _left;

				var _height = _bottom - _top;

				return {
					top: _top,
					bottom: _bottom,
					left: _left,
					right: _right,
					width: _width,
					height: _height
				};
			}

			default:
			{
				return boundingRect;
			}
		}
	}

	var sticky = {
		name: 'sticky',
		defaultValue: false,
		fn: function fn(instance) {
			var reference = instance.reference,
				popper = instance.popper;

			function getReference() {
				return instance.popperInstance ? instance.popperInstance.state.elements.reference : reference;
			}

			function shouldCheck(value) {
				return instance.props.sticky === true || instance.props.sticky === value;
			}

			var prevRefRect = null;
			var prevPopRect = null;

			function updatePosition() {
				var currentRefRect = shouldCheck('reference') ? getReference().getBoundingClientRect() : null;
				var currentPopRect = shouldCheck('popper') ? popper.getBoundingClientRect() : null;

				if (currentRefRect && areRectsDifferent(prevRefRect, currentRefRect) || currentPopRect && areRectsDifferent(prevPopRect, currentPopRect)) {
					if (instance.popperInstance) {
						instance.popperInstance.update();
					}
				}

				prevRefRect = currentRefRect;
				prevPopRect = currentPopRect;

				if (instance.state.isMounted) {
					requestAnimationFrame(updatePosition);
				}
			}

			return {
				onMount: function onMount() {
					if (instance.props.sticky) {
						updatePosition();
					}
				}
			};
		}
	};

	function areRectsDifferent(rectA, rectB) {
		if (rectA && rectB) {
			return rectA.top !== rectB.top || rectA.right !== rectB.right || rectA.bottom !== rectB.bottom || rectA.left !== rectB.left;
		}

		return true;
	}

	if (isBrowser) {
		injectCSS(css);
	}

	tippy.setDefaultProps({
		plugins: [animateFill, followCursor, inlinePositioning, sticky],
		render: render
	});
	tippy.createSingleton = createSingleton;
	tippy.delegate = delegate;
	tippy.hideAll = hideAll;
	tippy.roundArrow = ROUND_ARROW;

	return tippy;

})));
//# sourceMappingURL=tippy-bundle.umd.js.map

/**
 * Minified by jsDelivr using Terser v5.10.0.
 * Original file: /npm/throttle-debounce@5.0.0/umd/index.js
 *
 * Do NOT use SRI with dynamically generated files! More information: https://www.jsdelivr.com/using-sri-with-dynamic-files
 */
!function(e,o){"object"==typeof exports&&"undefined"!=typeof module?o(exports):"function"==typeof define&&define.amd?define(["exports"],o):o((e="undefined"!=typeof globalThis?globalThis:e||self).throttleDebounce={})}(this,(function(e){"use strict";function o(e,o,n){var t,i=n||{},d=i.noTrailing,u=void 0!==d&&d,f=i.noLeading,r=void 0!==f&&f,c=i.debounceMode,a=void 0===c?void 0:c,l=!1,v=0;function s(){t&&clearTimeout(t)}function p(){for(var n=arguments.length,i=new Array(n),d=0;d<n;d++)i[d]=arguments[d];var f=this,c=Date.now()-v;function p(){v=Date.now(),o.apply(f,i)}function b(){t=void 0}l||(r||!a||t||p(),s(),void 0===a&&c>e?r?(v=Date.now(),u||(t=setTimeout(a?b:p,e))):p():!0!==u&&(t=setTimeout(a?b:p,void 0===a?e-c:e)))}return p.cancel=function(e){var o=(e||{}).upcomingOnly,n=void 0!==o&&o;s(),l=!n},p}e.debounce=function(e,n,t){var i=(t||{}).atBegin;return o(e,n,{debounceMode:!1!==(void 0!==i&&i)})},e.throttle=o,Object.defineProperty(e,"__esModule",{value:!0})}));
//# sourceMappingURL=/sm/6c338db792fd7ea54613772f5e66199322564ea6837fbd87ad03561441b1a3d5.map
